var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcNavBack = function SvgIcNavBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#AEB5C0",
    points: "7.59 .733 11.829 4.972 10.83 5.972 10.812 5.953 7.499 9.267 6.5 8.268 9.069 5.698 .5 5.699 .5 4.199 9.057 4.198 6.591 1.732",
    transform: "rotate(-180 6 5)"
  })));
};
export default SvgIcNavBack;